import { render, staticRenderFns } from "./Sch.vue?vue&type=template&id=6edcfeda&scoped=true"
import script from "./Sch.vue?vue&type=script&lang=js"
export * from "./Sch.vue?vue&type=script&lang=js"
import style0 from "./Sch.vue?vue&type=style&index=0&id=6edcfeda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edcfeda",
  null
  
)

export default component.exports